import React, { useState, useRef } from "react";
import CssTransition from "../../../../component/layout/css-transition";
import Table from "../../../../component/table";
import { useSelector } from "react-redux";
import { getDateWithFormat } from "../../../../utils";
import { useNavigate } from "react-router-dom";

function ProductionRequirementModal({
  requirementModalOpen,
  setRequirementModalOpen,
  allSelectedProducts,
  setAllSelectedProducts,
}) {
  const modalContent = useRef();
  const navigate = useNavigate();

  // State
  const [loader, setLoader] = useState(false);

  const { productionRequirementData } = useSelector(
    (state) => state.productionOrder
  );

  const handleSelectAll = () => {
    if (allSelectedProducts.length === 0) {
      setAllSelectedProducts(
        productionRequirementData.map((item) => item.product_name)
      );
    } else {
      setAllSelectedProducts([]);
    }
  };

  const handleSubmit = () => {
    setRequirementModalOpen(false);
  };

  return (
    <>
      <CssTransition
        className="fixed -inset-2 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={requirementModalOpen}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
      />
      <CssTransition
        id="createPurchaseOrder"
        className="fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6"
        role="dialog"
        aria-modal="true"
        show={requirementModalOpen}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
      >
        <div
          ref={modalContent}
          className="bg-white w-full overflow-auto max-w-2xl max-h-full rounded-[20px] shadow-lg flex flex-col"
        >
          <div className="py-8 px-6 space-y-10">
            <h2 className="text-[#1E293B] font-semibold text-center">
              Create Production Order
            </h2>
            <div className="w-full max-h-[425px]">
              <div className="max-h-[425px] max-w-full overflow-y-auto scrollbar scrollbar-w-2 scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                <Table
                  heads={[
                    {
                      headName: (
                        <div className="flex items-center space-x-2">
                          <div class="flex items-center">
                            <input
                              id="customCheckbox"
                              type="checkbox"
                              className={`${
                                allSelectedProducts.length ===
                                  productionRequirementData.length &&
                                allSelectedProducts.length > 0
                                  ? "block form-checkbox cursor-pointer"
                                  : "hidden"
                              }`}
                              checked={allSelectedProducts.length > 0}
                              onChange={(e) => {
                                handleSelectAll();
                              }}
                              disabled={productionRequirementData.length === 0}
                            />
                            <label
                              for="customCheckbox"
                              class={`${
                                allSelectedProducts.length ===
                                  productionRequirementData.length &&
                                allSelectedProducts.length > 0
                                  ? "hidden"
                                  : "block"
                              } form-checkbox flex items-center justify-center cursor-pointer ${
                                allSelectedProducts.length > 0
                                  ? "!bg-[--bg-color-500]"
                                  : "!bg-white"
                              }`}
                            >
                              <span
                                class={`text-white ${
                                  allSelectedProducts.length > 0
                                    ? "block"
                                    : "hidden"
                                }`}
                              >
                                &ndash;
                              </span>
                            </label>
                          </div>

                          <span>Products</span>
                        </div>
                      ),
                      isSort: false,
                      value: "product_name",
                    },
                    {
                      headName: "Required Arrival",
                      isSort: false,
                      value: "planned_date",
                    },
                    // {
                    //   headName: "Feasible Arrival",
                    //   isSort: false,
                    //   value: "planned_date",
                    // }
                  ]}
                  tClass="table-fixed w-full border-separate border-spacing-y-2"
                  hClass="text-[14px] leading-2 text-[#1E293B] !bg-[--bg-color-50] tracking-wide sticky top-0 text-left font-semibold"
                  bClass="text-[14px] !text-left"
                  thClass={`h-[40px] whitespace-nowrap text-left font-semibold first:rounded-l last:rounded-r max-w-10 sticky top-0 first:pl-4`}
                >
                  {productionRequirementData.length > 0 ? (
                    productionRequirementData.map((item) => (
                      <tr
                        className="whitespace-nowrap bg-[--bg-color-50] h-[40px] text-center cursor-pointer"
                        onClick={(e) => {
                          if (allSelectedProducts.includes(item.product_name)) {
                            setAllSelectedProducts(
                              allSelectedProducts.filter(
                                (ele) => ele !== item.product_name
                              )
                            );
                          } else {
                            console.log("row handle click inside else");
                            setAllSelectedProducts([
                              ...allSelectedProducts,
                              item.product_name,
                            ]);
                          }
                        }}
                      >
                        <td
                          title={item.job_id}
                          className="text-left pl-4 rounded-tl rounded-bl"
                        >
                          <div className="max-w-full truncate space-x-2">
                            <input
                              className="form-checkbox cursor-pointer"
                              type="checkbox"
                              checked={allSelectedProducts.includes(
                                item.product_name
                              )}
                              onChange={(e) => {
                                if (
                                  allSelectedProducts.includes(
                                    item.product_name
                                  )
                                ) {
                                  setAllSelectedProducts(
                                    allSelectedProducts.filter(
                                      (ele) => ele !== item.product_name
                                    )
                                  );
                                } else {
                                  setAllSelectedProducts([
                                    ...allSelectedProducts,
                                    item.product_name,
                                  ]);
                                }
                              }}
                            />
                            <span>{item.product_name}</span>
                          </div>
                        </td>
                        <td className="text-left rounded-tr rounded-br">
                          {getDateWithFormat(item.required_arrival)}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr className="whitespace-nowrap bg-[--bg-color-50] h-[40px] text-center cursor-pointer">
                      <td colSpan={2}>No Data Found</td>
                    </tr>
                  )}
                </Table>
              </div>
            </div>
            <div className="flex justify-center items-center space-x-4">
              <button
                className="btn bg-[#fff] border-slate-200 hover:border-slate-300 text-slate-600 w-40"
                onClick={() => {
                  setRequirementModalOpen(false);
                  setAllSelectedProducts([]);
                }}
                disabled={loader}
              >
                Cancel
              </button>
              <button
                className={`btn ${
                  allSelectedProducts?.length === 0
                    ? "pointer-events-none bg-[--bg-color-400]"
                    : "bg-[--bg-color-500]"
                }  text-white w-40`}
                onClick={() => {
                  setRequirementModalOpen(false);
                  navigate("/order/create_production_order", {
                    state: { allSelectedProducts, update: null },
                  });
                }}
                disabled={allSelectedProducts?.length === 0}
              >
                {loader ? (
                  <svg
                    className="animate-spin w-5 h-45 fill-current shrink-0"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
                  </svg>
                ) : (
                  "Create"
                )}
              </button>
            </div>
          </div>
        </div>
      </CssTransition>
    </>
  );
}

export default ProductionRequirementModal;
